import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from "./Layout";
import HomePage from "./pages/HomePage";
import ProfilePage from "./pages/ProfilePage";
import SearchPage from "./pages/SearchPage";
import NavigationPage from "./pages/NavigationPage";
import NavigationDynamicPage from "./pages/NavigationDynamicPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import ApplyOnlinePage from "./pages/ApplyOnlinePage";
import ProgramsDynamicPage from "./pages/ProgramsDynamicPage";
import SingleDynamicPage from "./pages/SingleDynamicPage";
import SingleProgramsDynamicPage from "./pages/SingleProgramsDynamicPage";
import ProgramsPage from "./pages/ProgramsPage";
import ContactPage from "./pages/ContactPage";
import PageNotFound from "./pages/PageNotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        element: <HomePage />,
        index: true,
      },
      {
        element: <ContactPage />,
        path: "/contact",
      },
      {
        element: <ProfilePage />,
        path: "/profile",
      },
      {
        element: <SearchPage />,
        path: "/search",
      },
      {
        element: <ProgramsPage />,
        path: "/programs",
      },
      {
        element: <ProgramsDynamicPage />,
        path: "/programs/:id",
      },
      {
        element: <AdmissionsPage />,
        path: "/admissions",
      },
      {
        element: <NavigationPage />,
        path: "/navigation",
      },
      {
        element: <NavigationDynamicPage />,
        path: "/navigation/:id",
      },
      {
        element: <SingleDynamicPage />,
        path: "/single-page/:id",
      },
      {
        element: <SingleProgramsDynamicPage />,
        path: "/single-programs/:id",
      },
      {
        element: <ApplyOnlinePage />,
        path: "/apply-online",
      },
      {
        path: "/page-not-found",
        element: <PageNotFound />,
      },
      {
        path: "*",
        element: <Navigate to="/page-not-found" replace />,
      },
    ],
  },
]);

export default router;
